import { environment } from '@environments/environment';

/**
 * URL base para la API - configurada desde variables de entorno
 * Para desarrollo: http://localhost:8000/api/v1
 * Para producción: http://217.71.206.131:74/api/v1
 */
export const API_BASE_URL = environment.apiBaseUrl;

/**
 * Constantes para las rutas de API
 * Centraliza todas las rutas de endpoints para facilitar el mantenimiento
 */
export const API_ROUTES = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    PROFILE: '/auth/profile',
    REGISTER: '/auth/register',
    REFRESH_TOKEN: '/auth/refresh-token',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password'
  },
  DASHBOARD: {
    BASE: '/purchases/dashboard',
    SALES: {
      DAILY: '/purchases/dashboard/sales/daily',
      MONTHLY: '/purchases/dashboard/sales/monthly',
      YEARLY: '/purchases/dashboard/sales/yearly'
    },
    SERVICES: '/purchases/dashboard/services'
  },
  USERS: {
    BASE: '/users',
    GET_ALL: '/users',
    GET_BY_ID: (id: string | number) => `/users/${id}`,
    CREATE: '/users',
    UPDATE: (id: string | number) => `/users/${id}`,
    DELETE: (id: string | number) => `/users/${id}`,
    GET_WITH_CHILDREN: (id: string | number) => `/users/${id}/children`,
    CHANGE_STATUS: (id: string | number) => `/users/${id}/status`,
    TOGGLE_STATUS: (id: string | number) => `/users/${id}/toggle-status`
  },
  CHILDREN: {
    BASE: '/children',
    GET_ALL: '/children',
    GET_ALL_ADMIN: '/children/all', // Nuevo endpoint para admin - lista todos los hijos
    GET_BY_ID: (id: string | number) => `/children/${id}`,
    CREATE: '/children',
    UPDATE: (id: string | number) => `/children/${id}`,
    DELETE: (id: string | number) => `/children/${id}`,
    TOGGLE_STATUS: (id: string | number) => `/children/${id}/toggle-status`
  },
  COURSES: {
    BASE: '/courses',
    GET_ALL: '/courses',
    GET_BY_ID: (id: string | number) => `/courses/${id}`,
    CREATE: '/courses',
    UPDATE: (id: string | number) => `/courses/${id}`,
    DELETE: (id: string | number) => `/courses/${id}`,
    GET_STUDENTS: (id: string | number) => `/courses/${id}/students`
  },
  SERVICES: {
    BASE: '/services',
    GET_ALL: '/services',
    GET_BY_ID: (id: string | number) => `/services/${id}`,
    CREATE: '/services',
    UPDATE: (id: string | number) => `/services/${id}`,
    DELETE: (id: string | number) => `/services/${id}`,
    GET_COURSES: (id: string | number) => `/services/${id}/courses`
  },
  ENROLLMENTS: {
    BASE: '/enrollments',
    GET_ALL: '/enrollments',
    GET_ALL_ADMIN: '/enrollments/all', // Nuevo endpoint para admin - lista todas las matrículas
    GET_BY_ID: (id: string | number) => `/enrollments/${id}`,
    CREATE: '/enrollments',
    UPDATE: (id: string | number) => `/enrollments/${id}`,
    DELETE: (id: string | number) => `/enrollments/${id}`,
    ELIGIBILITY: {
      OVERRIDE: '/enrollments/eligibility/override', // PUT - Para modificar permisos de elegibilidad
      CHECK_USER: (userId: string | number, courseId: string | number) => `/admin/enrollments/eligibility/user/${userId}/course/${courseId}` // GET - Verificar elegibilidad de hijos de usuario
    }
  },
  FINANCIAL: {
    BASE: '/financial',
    MOVEMENTS: '/financial/movements',
    REPORTS: '/financial/reports',
    INVOICES: '/financial/invoices',
    GET_INVOICE: (id: string | number) => `/financial/invoices/${id}`
  },
  NOTIFICATIONS: {
    BASE: '/notifications',
    GET_ALL: '/notifications',
    GET_UNREAD: '/notifications/unread',
    MARK_READ: (id: string | number) => `/notifications/${id}/read`,
    MARK_ALL_READ: '/notifications/read-all'
  },
  STATES: {
    GET_ALL: '/states',
    GET_BY_ID: (id: string | number) => `/states/${id}`
  },
  CITIES: {
    GET_ALL: '/cities',
    GET_BY_STATE: (stateId: string | number) => `/cities/state/${stateId}`,
    GET_BY_ID: (id: string | number) => `/cities/${id}`
  },
  DOCUMENTS: {
    BASE: '/documents',
    GET_ALL: '/documents',
    GET_BY_CHILD: (childId: string | number) => `/documents/child/${childId}`,
    GET_CHILD_DOCS: (childId: string | number) => `/documents/child/${childId}`,
    GET_BY_ID: (id: string | number) => `/documents/${id}`,
    CREATE: '/documents',
    UPDATE: (id: string | number) => `/documents/${id}`,
    DELETE: (id: string | number) => `/documents/${id}`,
    GET_COURSE_DOCS: (courseId: string | number) => `/documents/course/${courseId}`,
    GET_USER_DOCS: (userId: string | number) => `/documents/user/${userId}`,
    DOWNLOAD: (id: string | number) => `/documents/${id}/download`,
    GET_CONTENT: (id: string | number) => `/documents/${id}/content`,
    REVIEW: (id: string | number) => `/documents/${id}/review`,
    CHILD_COURSE_DETAILS: (childId: string | number, courseId: string | number) =>
      `/documents/child/${childId}/course/${courseId}`
  },
  COURSE_DOCUMENTS: {
    BASE: '/course-documents',
    GET_ALL: '/course-documents',
    GET_BY_COURSE: (courseId: number | string) => `/course-documents/course/${courseId}`,
    GET_BY_ID: (id: number | string) => `/course-documents/${id}`,
    GET: (id: number | string) => `/course-documents/${id}`,
    UPDATE: (id: number | string) => `/course-documents/${id}`,
    DELETE: (id: number | string) => `/course-documents/${id}`,
    SUBMISSIONS: (id: number | string) => `/course-documents/${id}/submissions`
  }
};
